import APP_ACTIONS from '../constants/app-actions';
import localStorageAPI from '../services/local-storage-api';

const navigation = {
    addKatapulkNavigation: (navigation) => (dispatch, getState) => {
        dispatch({
            type: APP_ACTIONS.ADD_KATAPULK_NAVIGATION,
            payload: {
                navigation: {
                    katapulk: navigation,
                },
            },
        });
        localStorageAPI.save(getState());
    },
};

export default navigation;



/** WEBPACK FOOTER **
 ** ./src/actions/navigation.js
 **/